import Vue from 'vue';
import axios from 'axios';
import defaultUrl from './urls.js';
let _this = new Vue({});
// 创建axios
const _axios = axios.create({
    baseURL: defaultUrl,
    timeout: 30000,
    withCredentials: false,
    // headers: {
    //     "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    // }
});
// 请求拦截器
_axios.interceptors.request.use(config => {
    let token = window.localStorage.getItem('token') ? window.localStorage.getItem('token') : '';
    config.headers.Authorization = token ? 'Bearer' + token : 'Bearer';
    return config;
}, error => {
    return Promise.reject(error);
});
// 响应拦截器
_axios.interceptors.response.use(response => {
    if(response.data.status >= 40100) {
        // 40100 token已过期, 40101 token无效, 40102 token被列入黑名单, 40103 未传递token
        // 通知重新登录
        _this.Bus.$emit('haveToken', true);
    }
    return response;
}, error => {
    return Promise.reject(error);
});
export default _axios;


// WEBPACK FOOTER //
// ./src/ws/domain.js